import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, ComponentRef, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { GlobalMessageService, OccEndpointsService, RoutingService, TranslatePipe } from '@spartacus/core';
import { LAUNCH_CALLER, LaunchDialogService } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { KnBrCaseUpdateDialogComponent } from 'src/app/kn-br-case-update-dialog/kn-br-case-update-dialog.component';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { RemoveLeadingZerosPipe } from 'src/app/shared/pipe/kn-br-custom-pipes/remove-leading-zeros.pipe';
import { KnBrCustomerContextService } from 'src/app/store/kn-br-customer-context/kn-br-customer-context.service';
import { KnBrQuotesService } from 'src/app/store/kn-br-quotes/kn-br-quotes.service';
import { KNBR_CASE_LIST, KNBR_GET_CASE_LISTING_STATUSES, KNBR_GET_CASE_TYPES } from 'src/constants/api.endpoints.constant';
import { NgSelectComponent, NgOptionTemplateDirective, NgMultiLabelTemplateDirective } from '@ng-select/ng-select';
import { SlicePipe } from '@angular/common';
@Component({
    selector: 'kn-br-case-listing-result',
    templateUrl: './kn-br-case-listing-result.component.html',
    styleUrls: ['./kn-br-case-listing-result.component.scss'],
    providers: [RemoveLeadingZerosPipe],
    imports: [ReactiveFormsModule, NgSelectComponent, NgOptionTemplateDirective, FormsModule, NgMultiLabelTemplateDirective, NgbTooltip, SlicePipe, TranslatePipe]
})
export class KnBrCaseListingResultComponent implements OnInit, OnDestroy {
isRequiredFieldsFilled(): any {
throw new Error('Method not implemented.');
}
  caseUpdateModalRef: any;
  searchCriteria: any;

  public formGroup: FormGroup;

  customerId: string;
  submitted: boolean;
  showSpinner: void | Observable<ComponentRef<any>>;
  ticketsData = [];
  paginate: any;
  apiCalled = false;
  selectedSortValue = 'byDate';
  initialPayload = {
    currentPage: 0,
    pageSize: 50,
  };
  vieworManageHeadingToolTipText = `To view an existing case, click "View" under Action. To add a comment or file to an In Progress case click “Update” under Action`;
  caseListSearchForm: UntypedFormGroup;
  allApiSubscriptions = new Subscription();
  caseTypesData = []
  statusListData = []
  sortByData = [
    {name: 'Created on Date', value: 'byDate'},
    {name: 'Last Updated', value: 'byModifiedTime'},
    {name: 'Case Type', value: 'byCaseType'},
    {name: 'Status', value: 'byStatus' }
  ]

  constructor(
    protected fb: UntypedFormBuilder,
    protected knBrQuoteService: KnBrQuotesService,
    protected knBrCommonService: KnBrCommonService,
    protected knBrCustomerContextService: KnBrCustomerContextService,
    protected removeLeadingZerosPipe: RemoveLeadingZerosPipe,
    protected activatedRoute: ActivatedRoute,
    protected http: HttpClient,
    private endPointService: OccEndpointsService,
    protected cdr: ChangeDetectorRef,
    protected globalMessageService: GlobalMessageService,
    protected launchDialogService: LaunchDialogService,
    protected vcr: ViewContainerRef,
    protected modalService: NgbModal,
    protected routeService: RoutingService,

  ) {}

  ngOnInit(): void {
    this.knBrCustomerContextService.getActiveCustomerNumber().subscribe((response) => {
      this.customerId = response ? response : 'current';
      this.getCaseListingDetails(this.initialPayload);
    });
    this.getCaseTypesData();
    this.getCaseListingStatusesList();
    this.initForm();
  }

  initForm() {
    this.caseListSearchForm = this.fb.group({
      svcCaseNumber: [null, []],
      caseType: [null, []],
      orderNumber: [null, []],
      invoiceNumber: [null, []],
      status: [null, []],
      sort: [this.sortByData[0].value, []],
    });
  }

  submitForm() {
    this.submitted = true;
    const payload = this.caseListSearchForm.getRawValue();
    const updatedPayload = {...this.initialPayload, ...payload}
    this.getCaseListingDetails(updatedPayload);
  }

  getCaseListingStatusesList() {
    const statusListUrl = this.endPointService.buildUrl(KNBR_GET_CASE_LISTING_STATUSES(this.customerId));
    this.allApiSubscriptions.add(this.http.get(statusListUrl).subscribe(resp => {
      const formattedResponse = Object.keys(resp).map((key) => ({ name: resp[key], value: key }));
      this.statusListData = formattedResponse;
    }))
  }

  getCaseTypesData() {
    const url = this.endPointService.buildUrl(KNBR_GET_CASE_TYPES(this.customerId), {queryParams: {filterCaseTypes: false}});
    this.allApiSubscriptions.add(this.http.get(url).subscribe(
      (response) => {
        const formattedResponse = Object.keys(response).map((key) => ({ name: response[key], value: key }));
        const sortedFormat = this.knBrCommonService.alphabeticalSort(formattedResponse, 'name');
        this.caseTypesData = sortedFormat;
      }
    ));
  }

  onSpinnerLoading(isLoading) {
    if (isLoading) {
      this.showSpinner = this.launchDialogService.launch(LAUNCH_CALLER.PLACE_ORDER_SPINNER, this.vcr);
    } else {
      if (this.showSpinner) {
        this.showSpinner
          .subscribe((component) => {
            this.launchDialogService.clear(LAUNCH_CALLER.PLACE_ORDER_SPINNER);
            component.destroy();
          })
          .unsubscribe();
      }
    }
  }

  getCaseListingDetails(payload?: any) {
    this.onSpinnerLoading(true);
    const caseListingUrl = this.endPointService.buildUrl(KNBR_CASE_LIST(this.customerId), {
      queryParams: payload,
    });
    this.allApiSubscriptions.add(this.http.get(caseListingUrl).subscribe((response: any) => {
      if(payload.currentPage === 0) {
        this.ticketsData = response.tickets
      } else  {
        this.ticketsData.push(...response.tickets);
      }
      this.paginate = response.pagination;
      this.searchCriteria = {
        ...payload,
        pageSize: response.pagination.pageSize,
        currentPage: response.pagination.currentPage,
      }
      this.apiCalled = true;
      this.onSpinnerLoading(false);
      this.cdr.detectChanges();
    }, (error) => {
      this.onSpinnerLoading(false);
    }));
  }

  loadMore(currentPage: number) {
    this.searchCriteria.currentPage = currentPage + 1;
    this.getCaseListingDetails(this.searchCriteria);
  }

  handleCaseUpdateClick(ticketRow) {
    let caseUpdateModalRef = this.modalService.open(KnBrCaseUpdateDialogComponent, {});
    caseUpdateModalRef.componentInstance.ticketInfo = ticketRow;
    caseUpdateModalRef.result.then((comment) => {}).catch((error) => {});
  }

  resetTheForm() {
    this.submitted = false;
    this.caseListSearchForm.reset();
    this.getCaseListingDetails(this.initialPayload);
  }

  handleViewCaseClick(ticketData) {
    const url = `my-account/case-detail/${ticketData.svcCaseNumber}?ticketID=${ticketData.ticketId}`
    this.routeService.goByUrl(url);
  }

  ngOnDestroy(): void {
    this.ticketsData = [];
    this.paginate = {};
    this.searchCriteria = {};
    this.allApiSubscriptions.unsubscribe();
  }
}
